import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=74549250&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeBanner.vue?vue&type=style&index=0&id=74549250&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74549250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74549250')) {
      api.createRecord('74549250', component.options)
    } else {
      api.reload('74549250', component.options)
    }
    module.hot.accept("./HomeBanner.vue?vue&type=template&id=74549250&scoped=true", function () {
      api.rerender('74549250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/home/HomeBanner.vue"
export default component.exports